module.exports = __webpack_public_path__ + "img/yt.9d0be1d4.svg";